import * as CONFIG from './config';


exports.getAddUserRoleLookup = async function () {
    // console.log("getAddUserRoleLookup==>");
    const res= await CONFIG.httpGet('/role/loadroles');
    return res;
}

exports.getAPIVersion = async function () {
    // console.log("getAddUserRoleLookup==>");
    const res= await CONFIG.httpGet('/');
    return res;
}


// WEBPACK FOOTER //
// ./api/lookup.js